import { SecureRoute } from '@okta/okta-react';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { Switch, useRouteMatch } from 'react-router-dom';
import { ErrorBoundary } from 'components/molecules/error-boundary';
import { ErrorBoundaryFallback } from 'components/molecules/error-boundary/fallback';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { ProjectDetailRoute } from './detail';
import { ProjectListV2Page } from './list-v2';
import { ProjectSettings } from './settings';

export const ProjectRoute: FC = () => {
  const { path } = useRouteMatch();

  return (
    <ErrorBoundary fallback={ErrorBoundaryFallback}>
      <Helmet>
        <title>{useTranslation('projects.title')}</title>
      </Helmet>
      <Switch>
        <SecureRoute
          path={RoutePaths.projectsCreate}
          component={ProjectListV2Page}
        />
        <SecureRoute
          path={RoutePaths.projectSettings}
          component={ProjectSettings}
        />
        <SecureRoute
          path={RoutePaths.projectDetail}
          component={ProjectDetailRoute}
        />
        <SecureRoute path={path} component={ProjectListV2Page} />
      </Switch>
    </ErrorBoundary>
  );
};
